import { createElement, forwardRef } from "react";
import { m, useReducedMotion } from "framer-motion";
import {
  getTransition,
  resolveVariant,
  variants,
  viewport,
} from "../../../utils/motionVariants";
import { getMotionComponent, resolveTag } from "../Motion/motionPrimitives";

/**
 * Single-element viewport reveal. For groups, prefer MotionStagger + MotionItem.
 */
const MotionReveal = forwardRef(function MotionReveal(
  {
    as = "div",
    variant = "fadeUp",
    delay = 0,
    className,
    children,
    viewport: viewportProp,
    immediate = false,
    ...props
  },
  ref
) {
  const reduceMotion = useReducedMotion();
  const tag = resolveTag(as);
  const variantKey = resolveVariant(variant);
  const motionVariants = variants[variantKey] || variants.fadeUp;

  if (reduceMotion) {
    return createElement(tag, { ref, className, ...props }, children);
  }

  const Component = getMotionComponent(m, tag);
  const resolvedViewport = viewportProp ?? viewport;

  return createElement(
    Component,
    {
      ref,
      initial: "hidden",
      ...(immediate
        ? { animate: "visible" }
        : { whileInView: "visible", viewport: resolvedViewport }),
      variants: motionVariants,
      transition: getTransition(delay),
      className,
      ...props,
    },
    children
  );
});

MotionReveal.displayName = "MotionReveal";

export default MotionReveal;
